import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from '../../../Utils';
import { connect, actions } from '../../../Store';
import BaseList from '../BaseList';
import AlertPopup from '../../../Components/AlertPopup';
//import SprayFillingConfigurator from '../../SprayFillingConfigurator';
import API2 from '../../../API2';
import { Title } from '../../../Components/ReusableComponents';

const SprayConfiguratorWrapper = styled.div`
  padding-bottom: ${rem(400)};
`;

class SprayConfigurator extends BaseList {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      title: __('Konfigurátor sprejov'),
      notFoundMessage: __('Nepodarilo sa načítať produkty pre tónovanie'),
      isProduct: true,
      loading: false,

      showFilter: false,
      showSearch: false,
      showPager: false,
      cartLoading: false,
      items: [''],
    };

    actions.setActiveMenuItem('76');
  }
  generateRandomId() {
    return Math.floor(1000000000 + Math.random() * 9000000000).toString();
  }
  async addToCart(products) {
    const { activeCart } = this.props;

    this.setState({
      addLoading: true,
    });
    const myCarts = await API2.getCartsAction();
    const selectedCart = myCarts.carts.find(c => c._id === activeCart);
    let cartToLoad = selectedCart;

    if (!selectedCart) {
      cartToLoad = await API2.createCartAction({ body: { title: 'cart1' } });
    }
    const allData = products.map(p => {
      const dataToSend = {
        quantity: p.quantity,
        product_id: p._id,
        configuration_id: p.configuration_id,
      };

      if (
        p.colorCode &&
        p.toningSystemId &&
        p.colorCardId &&
        (!p.finished_shade || !p.finished_shade.length)
      ) {
        if (p.colorCode) {
          dataToSend.color_code = p.colorCode;
          dataToSend.toningSystemId = p.toningSystemId;
          dataToSend.colorCardId = p.colorCardId;
        }
        dataToSend.coefficient =
          p.variantParams &&
          p.variantParams.find(vp => vp.name === 'Koeficient tónovania')
            ? Number(
                p.variantParams.find(vp => vp.name === 'Koeficient tónovania')
                  .value,
              ) || 1
            : p.coefficient || 1;
      }
      return dataToSend;
    });
    try {
      const cartResult = await API2.postCartConfigurationItemsAction(
        cartToLoad._id,
        {
          body: allData,
          // addToExistingItem: false,
        },
      );
      actions.updateCarts(cartResult.cart);
    } catch (e) {
      console.log(e);
    }
  }

  async addProductsToCart(products) {
    this.setState({
      cartLoading: true,
    });
    const configurationId = this.generateRandomId();
    await this.addToCart(
      products.map(p => {
        return {
          _id: p._id,
          colorCode: p.shadeId,
          toningSystemId: p.toningSystemId,
          colorCardId: p.colorCardId,
          quantity: p.quantity,
          configuration_id: configurationId,
        };
      }),
    );
    this.setState({
      cartLoading: false,
      showSuccess: true,
    });
  }

  renderItemsList() {
    return (
      <SprayConfiguratorWrapper>
        <Title>{'Sekcia momentálne nedostupná'}</Title>
        {/* <SprayFillingConfigurator
          confirmButtonTitle={__('Pridať do košíka')}
          showButton
          applyMargin
          cartLoading={this.state.cartLoading}
          addLoading={this.state.addLoading}
          onConfirm={products => this.addProductsToCart(products)}
          location={this.props.location}
          history={this.props.history}
        /> */}
      </SprayConfiguratorWrapper>
    );
  }

  render() {
    const { showSuccess } = this.state;
    return (
      <React.Fragment>
        <AlertPopup
          alignUnderHeader
          display={showSuccess}
          text={__('Produkt bol pridaný do objednávky')}
          success
          onClose={() =>
            this.setState({
              showSuccess: false,
            })
          }
          onSubmit={() =>
            this.setState({
              showSuccess: false,
            })
          }
        />
        {super.render()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(SprayConfigurator);



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/SprayConfigurator/index.jsx